import MyTable from "components/UIElements/MyTable";

export default function ReportTrips({ endPoint, exportFilename }) {

    const columns = [
        {
            title: 'PlateNo',
            dataIndex: 'plateNumber',
            key: 'plateNumber',
        },
        {
            title: 'PolicyNo',
            dataIndex: 'policyNumber',
            key: 'policyNumber',
        },
        {
            title: 'OBD',
            dataIndex: 'deviceImei',
            key: 'deviceImei',
        },
        {
            title: 'Channel',
            key: 'channel',
            dataIndex: 'channel'
        },
        {
            title: 'Start_Trip',
            key: 'startDate',
            dataIndex: 'startDate',
        },
        {
            title: 'End_Trip',
            key: 'endDate',
            dataIndex: 'endDate',
        },
        {
            title: 'Klm',
            key: 'kilometers',
            dataIndex: 'kilometers',
        },
        {
            title: 'DeviceType',
            key: 'deviceType',
            dataIndex: 'deviceType',
        },
    ];

    return <MyTable endPoint={endPoint} columns={columns} exportFilename={exportFilename} />
}